"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleFuturesTPSLProcessor = void 0;
const SimpleFuturesAPI_1 = require("../../../apis/SimpleFuturesAPI");
const interface_1 = require("../../../interface");
const trade_utils_lib_1 = require("trade_utils_lib");
const errors_1 = require("../../../interface/errors");
const react_1 = require("react");
const context_1 = require("../../../context");
const Trade_1 = require("../../Trade");
const LeverageConfig_1 = require("../../FuturesConfig/FutureLeverageProvider/LeverageConfig");
const utils_1 = require("./utils");
const OpenTP_1 = require("./TPSLLimiter/OpenTP");
const OpenSL_1 = require("./TPSLLimiter/OpenSL");
const ActiveTP_1 = require("./TPSLLimiter/ActiveTP");
const ActiveSL_1 = require("./TPSLLimiter/ActiveSL");
__exportStar(require("./utils"), exports);
var SimpleFuturesTPSLProcessor;
(function (SimpleFuturesTPSLProcessor) {
    /**
     * 获取设置的止盈/止损的状态
     * @param tpOrSLParams
     * @param tpOrSLLimit
     */
    SimpleFuturesTPSLProcessor.getTPOrSLState = (tpOrSLParams, tpOrSLLimit) => {
        const v = (() => {
            var _a;
            if ((tpOrSLParams === null || tpOrSLParams === void 0 ? void 0 : tpOrSLParams.mode) === interface_1.SimpleFutures.TPSLMode.simple_trailing) {
                return (_a = tpOrSLParams.trailing) === null || _a === void 0 ? void 0 : _a.draw_down;
            }
            return utils_1.SimpleFuturesTPSLUtils.tpslValueShortcut(tpOrSLParams);
        })();
        if (!v) {
            return interface_1.SimpleFutures.TPSLStateEnum.not_set;
        }
        const value = new trade_utils_lib_1.SafeDecimal(v);
        let tpState = interface_1.SimpleFutures.TPSLStateEnum.normal;
        if (!tpOrSLLimit) {
            return tpState;
        }
        // 老代码逻辑默认inside
        const { type = "inside" } = tpOrSLLimit;
        if (type === "inside") {
            if (tpOrSLLimit.max && value.greaterThan(tpOrSLLimit.max)) {
                // 止盈大了
                tpState = interface_1.SimpleFutures.TPSLStateEnum.too_high;
            }
            else if (tpOrSLLimit.min && value.lessThan(tpOrSLLimit.min)) {
                // 止盈小了
                tpState = interface_1.SimpleFutures.TPSLStateEnum.too_low;
            }
        }
        else {
            if (tpOrSLLimit.min && value.gte(tpOrSLLimit.min) && tpOrSLLimit.max && value.lte(tpOrSLLimit.max)) {
                // 在范围内不合法
                tpState = interface_1.SimpleFutures.TPSLStateEnum.too_close;
            }
        }
        return tpState;
    };
    // 获取止盈止损的设置状态
    SimpleFuturesTPSLProcessor.useTPSLState = (tpslParams, TPSLLimit) => {
        return (0, react_1.useMemo)(() => {
            return { tp: SimpleFuturesTPSLProcessor.getTPOrSLState(tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.profit, TPSLLimit === null || TPSLLimit === void 0 ? void 0 : TPSLLimit.tp), sl: SimpleFuturesTPSLProcessor.getTPOrSLState(tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.loss, TPSLLimit === null || TPSLLimit === void 0 ? void 0 : TPSLLimit.sl) };
        }, [TPSLLimit === null || TPSLLimit === void 0 ? void 0 : TPSLLimit.sl, TPSLLimit === null || TPSLLimit === void 0 ? void 0 : TPSLLimit.tp, tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.loss, tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.profit]);
    };
    // 检查止盈止损是否合规
    SimpleFuturesTPSLProcessor.checkTPSLStateError = (state, limit) => {
        var _a, _b, _c, _d;
        const parseDecimal = (v) => {
            var _a;
            return ((_a = v === null || v === void 0 ? void 0 : v.mul(100).toFixed(2)) !== null && _a !== void 0 ? _a : "--") + "%";
        };
        if (state.tp === interface_1.SimpleFutures.TPSLStateEnum.too_high) {
            return (0, errors_1.cloneError)(errors_1.TRADE_TP_RATE_TOO_HIGH, { value: parseDecimal((_a = limit === null || limit === void 0 ? void 0 : limit.tp) === null || _a === void 0 ? void 0 : _a.max) });
        }
        else if (state.tp === interface_1.SimpleFutures.TPSLStateEnum.too_low) {
            return (0, errors_1.cloneError)(errors_1.TRADE_TP_RATE_TOO_LOW, { value: parseDecimal((_b = limit === null || limit === void 0 ? void 0 : limit.tp) === null || _b === void 0 ? void 0 : _b.min) });
        }
        if (state.sl === interface_1.SimpleFutures.TPSLStateEnum.too_high) {
            return (0, errors_1.cloneError)(errors_1.TRADE_SL_RATE_TOO_HIGH, { value: parseDecimal((_c = limit === null || limit === void 0 ? void 0 : limit.sl) === null || _c === void 0 ? void 0 : _c.max) });
        }
        else if (state.sl === interface_1.SimpleFutures.TPSLStateEnum.too_low) {
            return (0, errors_1.cloneError)(errors_1.TRADE_SL_RATE_TOO_LOW, { value: parseDecimal((_d = limit === null || limit === void 0 ? void 0 : limit.sl) === null || _d === void 0 ? void 0 : _d.min) });
        }
    };
    /**
     * 开单时TPSL的限制
     */
    function useOpenTPSLLimit({ base, quote, investInfo, leverage, feeRate, triggerPrice, priceByRateSide, tpslParams, }) {
        var _a;
        const symbol = `${base}/${quote}`;
        const { offsetLimit } = (_a = (0, Trade_1.useFuturesTPSLConfig)(symbol)) !== null && _a !== void 0 ? _a : {};
        const curLeverageRow = (0, LeverageConfig_1.useLeverageRowByNotionalValue)(symbol, new trade_utils_lib_1.SafeDecimal(investInfo === null || investInfo === void 0 ? void 0 : investInfo.invest).mul(leverage).toString());
        return (0, react_1.useMemo)(() => {
            var _a, _b;
            const forcedLossRatio = investInfo && curLeverageRow
                ? utils_1.SimpleFuturesTPSLUtils.calcForcedLossRatio({ investInfo, curLeverageRow, leverage })
                : undefined;
            const params = {
                investInfo,
                offsetLimit,
                leverageD: new trade_utils_lib_1.SafeDecimal(leverage),
                forcedLossRatio,
                takerFee: new trade_utils_lib_1.SafeDecimal(feeRate.takerFeeRate),
                triggerPrice,
                priceByRateSide,
                tpslParams,
            };
            return {
                tp: new OpenTP_1.OpenTP(Object.assign(Object.assign({}, params), { mode: ((_a = tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.profit) === null || _a === void 0 ? void 0 : _a.mode) || interface_1.SimpleFutures.TPSLMode.simple_rate })).valueOf(),
                sl: new OpenSL_1.OpenSL(Object.assign(Object.assign({}, params), { mode: ((_b = tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.loss) === null || _b === void 0 ? void 0 : _b.mode) || interface_1.SimpleFutures.TPSLMode.simple_rate })).valueOf(),
            };
        }, [curLeverageRow, feeRate.takerFeeRate, investInfo, leverage, offsetLimit, priceByRateSide, tpslParams, triggerPrice]);
    }
    SimpleFuturesTPSLProcessor.useOpenTPSLLimit = useOpenTPSLLimit;
    /**
     * 活跃仓位TPSL的限制
     */
    function useActiveTPSLLimit({ feeRate, order, isActive, tpslParams, }) {
        var _a;
        const ticker = (0, context_1.useFuturesTickerParseContext)({
            base: order === null || order === void 0 ? void 0 : order.base,
            quote: order === null || order === void 0 ? void 0 : order.quote,
            isFocused: isActive,
        });
        const { offsetLimit, warningOffsetLimit } = (_a = (0, Trade_1.useFuturesTPSLConfig)((order === null || order === void 0 ? void 0 : order.base) && (order === null || order === void 0 ? void 0 : order.quote) ? `${order === null || order === void 0 ? void 0 : order.base}/${order === null || order === void 0 ? void 0 : order.quote}` : undefined)) !== null && _a !== void 0 ? _a : {};
        return (0, react_1.useMemo)(() => {
            var _a, _b, _c, _d;
            const params = {
                order,
                curPrice: ticker === null || ticker === void 0 ? void 0 : ticker.latest,
                offsetLimit,
                takerFee: new trade_utils_lib_1.SafeDecimal(feeRate.takerFeeRate),
                tpslParams,
            };
            return {
                tp: new ActiveTP_1.ActiveTP(Object.assign(Object.assign({}, params), { mode: (_b = (_a = tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.profit) === null || _a === void 0 ? void 0 : _a.mode) !== null && _b !== void 0 ? _b : interface_1.SimpleFutures.TPSLMode.simple_rate })).valueOf(),
                sl: new ActiveSL_1.ActiveSL(Object.assign(Object.assign({}, params), { mode: (_d = (_c = tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.loss) === null || _c === void 0 ? void 0 : _c.mode) !== null && _d !== void 0 ? _d : interface_1.SimpleFutures.TPSLMode.simple_rate })).valueOf(),
            };
        }, [feeRate.takerFeeRate, offsetLimit, order, ticker === null || ticker === void 0 ? void 0 : ticker.latest, tpslParams]);
    }
    SimpleFuturesTPSLProcessor.useActiveTPSLLimit = useActiveTPSLLimit;
    SimpleFuturesTPSLProcessor.editOrderTPSL = (props) => {
        const { newParams, order } = props;
        return SimpleFuturesAPI_1.SimpleFuturesAPI.editTPSL({
            orderId: order.bu_order_id,
            tpsl: newParams,
        });
    };
})(SimpleFuturesTPSLProcessor = exports.SimpleFuturesTPSLProcessor || (exports.SimpleFuturesTPSLProcessor = {}));
